import { KalturaAssetDto } from '../composed';
import { KalturaUnmatchedItemsPolicy } from '../enums';
import { KalturaListGroupsRepresentativesFilter } from '../filters';
import { requestPhoenix } from '../network';
import {
  KalturaAssetFieldGroupBy,
  KalturaAssetListResponse,
  KalturaAssetMetaOrTagGroupBy,
  KalturaBaseAssetOrder,
  KalturaDetachedResponseProfile,
  KalturaFilterPager,
  KalturaOnDemandResponseProfile,
} from '../objects';
import { KalturaRepresentativeSelectionPolicy } from '../objects/KalturaRepresentativeSelectionPolicy';

type FetchAssetGroupRepresentativeListArgs = {
  filter?: KalturaListGroupsRepresentativesFilter;
  groupBy?: KalturaAssetFieldGroupBy | KalturaAssetMetaOrTagGroupBy;
  orderBy?: KalturaBaseAssetOrder;
  pager?: KalturaFilterPager;
  responseProfile?: KalturaDetachedResponseProfile | KalturaOnDemandResponseProfile;
  selectionPolicy?: KalturaRepresentativeSelectionPolicy;
  unmatchedItemsPolicy?: KalturaUnmatchedItemsPolicy;
};

/**
 * @see https://latest.api-docs-develop.ott.kaltura.com/api-docs/service/asset/action/groupRepresentativeList
 */
export async function fetchAssetGroupRepresentativeList<T = KalturaAssetDto>({
  filter,
  groupBy,
  orderBy,
  pager,
  responseProfile,
  selectionPolicy,
  unmatchedItemsPolicy,
}: FetchAssetGroupRepresentativeListArgs) {
  const response = await requestPhoenix<KalturaAssetListResponse<T>>({
    path: '/asset/action/groupRepresentativeList',
    body: { filter, groupBy, orderBy, pager, responseProfile, selectionPolicy, unmatchedItemsPolicy },
  });

  return {
    ...response,
    objects: response.objects?.length ? response.objects : [],
  };
}
